module.exports = __webpack_public_path__ + "img/logo.b5fe7050.svg";